import * as React from 'react';
import {useEffect} from 'react';
import api from "../../utils/api";
import DaumPostcode from 'react-daum-postcode';
import * as util from "../../utils/util";
import Top from "../Top";
import Bottom from "../Bottom";
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import InputAdornment from '@mui/material/InputAdornment';
import Button from '@mui/material/Button';
import {styled} from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import {useNavigate} from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import Fade from '@mui/material/Fade';
import Slide, {SlideProps} from '@mui/material/Slide';
import {TransitionProps} from '@mui/material/transitions';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import HomeIcon from '@mui/icons-material/Home';
import EmailIcon from '@mui/icons-material/Email';
import HttpsIcon from '@mui/icons-material/Https';
import {Checkbox, ListItemText, Modal} from "@mui/material";
import {FormContainer, PasswordElement, PasswordRepeatElement, TextFieldElement} from "react-hook-form-mui";
import ApartmentIcon from '@mui/icons-material/Apartment';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import WcIcon from '@mui/icons-material/Wc';
import zIndex from '@mui/material/styles/zIndex';
import { notifyApiError } from "../../utils/apiError";

function SlideTransition(props: SlideProps) {
  return <Slide {...props} direction="up" />;
}

const typeMemberProfile = {
  name: '', address: '', birthday: '', buildingNum: '', email: '', phone_number: '', height: '', weight: '',
  interest_disease: '', is_medicine: '', work_strength: '', companyId: '',companyType: '', family_info: '', id: ''
};
const typeSaveBasicParam = { cusId: '', phone: '', address: '', buildingNum: '', email: '', zipcode: '', beforePassword: '', afterPassword: '', afterPasswordCheck: '', familyInfo: '', grade: '' };
const saveCustomParam = { height: '', weight: '', workStrength: '', interestDisease: '', isMedicine: '' };

const MyPage = () => {
  const navigate = useNavigate();
  const [state, setState] = React.useState<{
    open: boolean;
    Transition: React.ComponentType<
      TransitionProps & {
        children: React.ReactElement<any, any>;
      }
    >;
  }>({
    open: false,
    Transition: Fade,
  });
  const [open, setOpen] = React.useState(false);
  const [isOpen, setIsOpen] = React.useState(false);
  const [memberProfile, setMemberProfile] = React.useState(typeMemberProfile);
  const [saveBasicParam, setSaveBasicParam] = React.useState(typeSaveBasicParam);
  const [heightError, setHeightError] = React.useState(false);
  const [weightError, setWeightError] = React.useState(false);
  const [code, setCode] = React.useState('');
  const [isCompanyIdCheck, setIsCompanyIdCheck] = React.useState(false);
  const [famName, setFamName] = React.useState('');
  const [famBirthDate, setFamBirthDate] = React.useState('');
  const [famRelation, setFamRelation] = React.useState('');
  const [famSelect, setFamSelect] = React.useState('none');
  
  useEffect(() => {
    getProfileData();
  }, []);
  
  function getProfileData(){
    api.get('permission/getProfile').then((res:any) => {
      setMemberProfile(res.data);
      setSaveBasicParam(res.data);
      setSaveBasicParam((prev) => true ? {...prev, phone: res.data.phone_number} : prev);
    }).catch(function (error:any) {
      console.log(error)
    });
  }
  
  const handleClick = (
    Transition: React.ComponentType<
      TransitionProps & {
        children: React.ReactElement<any, any>;
      }
    >,
  ) =>
  () => {
    setState({
      open: true,
      Transition,
    });
  };

  const handleClose = () => {
    setState({
      ...state,
      open: false,
    });
    setFamSelect('none');
    setCode('');
    setFamName('');
    setFamBirthDate('');
    setIsCompanyIdCheck(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  
  const handlePopClose = () => {
    setIsOpen(false)
  }
  
  // 회원 맞춤정보 수정
  function handleSaveMyInfo(){
    if(!heightError && !weightError){
      saveCustomParam.height = memberProfile.height;
      saveCustomParam.weight = memberProfile.weight;
      saveCustomParam.interestDisease = memberProfile.interest_disease;
      saveCustomParam.isMedicine = memberProfile.is_medicine;
      saveCustomParam.workStrength = memberProfile.work_strength;
      
      if(util.strNull(memberProfile.work_strength) === ''){
        alert('평상시 활동량을 입력해주세요.');
      }else if(util.strNull(memberProfile.interest_disease) === ''){
        alert('관심 질병을 입력해주세요.');
      }else if(util.strNull(memberProfile.is_medicine) === ''){
        alert('복용약을 입력해주세요.');
      }else{
        api.post('app/api/v1/AP_001_003', saveCustomParam).then((res:any) => {
          getProfileData();
          alert('정상적으로 저장되었습니다.');
        }).catch(function (error:any) {
          // 실패를 알리지 않으면 사용자는 저장된 줄 알고 화면을 떠난다
          notifyApiError(error, '맞춤 정보를 저장하지 못했습니다.');
        });
      }
    }else {
      alert('입력 항목을 확인해주세요.');
    }
  }
  
  // 회원 기본정보 수정
  async function handleSaveBasicInfo(data :any){
    const existingFamilyInfo = (memberProfile.family_info ?? '').trim();
    const relation = (famRelation ?? '').trim();

    if (!existingFamilyInfo && !relation) {
      alert('관계를 선택해주세요.');
      return;
    }
    saveBasicParam.cusId = decodeURIComponent(localStorage.getItem("userCusID") || '');
    saveBasicParam.phone = data.phone;
    saveBasicParam.email = data.email;
    saveBasicParam.address = data.address;
    saveBasicParam.buildingNum = data.buildingNum;
    saveBasicParam.zipcode = data.zipcode;
      
    if (existingFamilyInfo) {
      saveBasicParam.familyInfo = existingFamilyInfo;
    } else {
      // 새로 입력해야 하는 경우
      const familyInfo = buildFamilyInfo(famName, famRelation);

      if (!familyInfo) {
        alert('가족 정보(이름/관계)를 모두 입력해주세요.');
        return;
      }

      saveBasicParam.familyInfo = familyInfo;
    }

    await api.post('customer/api/v1/CU_002_004', saveBasicParam).then((res: any) => {

      if (data.beforePassword !== '' && data.afterPassword !== '' && data.afterPasswordCheck !== '') {
        saveBasicParam.beforePassword = data.beforePassword;
        saveBasicParam.afterPassword = data.afterPassword;
        saveBasicParam.afterPasswordCheck = data.afterPasswordCheck;
        api.post('customer/api/v1/CU_002_003', saveBasicParam).then((res: any) => {  // 비밀변호 변경 시, 로그아웃 후 로그인 화면으로 이동
          if (res.data.message === 'success') { // 비밀번호 변경 성공
            alert('내정보와 비밀번호 변경이 정상적으로 수정되어 로그아웃됩니다.');
            util.clearLoginStorage();
            // replace — 뒤로가기로 로그아웃된 마이페이지에 다시 들어가지 않게 한다
            navigate('/login', { replace: true });
          } else { // 비밀번호 변경 실패
            alert('비밀번호 변경 중 오류가 발생하였습니다. 현재 비밀번호를 확인하여 다시 시도해주세요.');
            handleClose();
            getProfileData();
          }
        }).catch(function (error: any) {
          // 여기서 조용히 넘기면 화면은 그대로고 로그아웃도 안 돼서,
          // 사용자는 비밀번호가 바뀐 줄 알고 다음 로그인에서 실패한다.
          // 기본 정보는 이미 저장된 상태라 그 사실도 함께 알린다.
          notifyApiError(error, '내 정보는 저장했지만 비밀번호는 변경하지 못했습니다.');
          handleClose();
          getProfileData();
        });
      } else {  // 기본 정보만 변경한 경우, 현재 페이지 로드
        alert('내정보가 정상적으로 수정되었습니다.');
        handleClose();
        getProfileData();
      }
    }).catch(function (error: any) {
      notifyApiError(error, '내 정보를 저장하지 못했습니다.');
    });
  }

  //가족관계 설정
  function buildFamilyInfo(famName: any, famRelation: any): string {
    const name = (famName ?? '').trim();
    const relation = (famRelation ?? '').trim();
    if (!name || !relation) return '';
    return `${name}의 ${relation}`;
  }
  
  // 신장 입력 핸들러
  function handleChangeHeight(val: any) {
    setMemberProfile((prev) => true ? {...prev, height: val} : prev);
    if (val >= 50 && val <= 250) {
      setHeightError(false);
    } else {
      setHeightError(true);
    }
  }

  // 체중 입력 핸들러
  function handleChangeWeight(val: any) {
    setMemberProfile((prev) => true ? {...prev, weight: val} : prev);
    if (val >= 10 && val <= 300) {
      setWeightError(false);
    } else {
      setWeightError(true);
    }
  }
  
  const handleComplete = (data :any) => {
    setSaveBasicParam((prev) => true ? {...prev, address: data.address} : prev);
    setSaveBasicParam((prev) => true ? {...prev, zipcode: data.zonecode} : prev);
    handlePopClose();
  };

  
  function isCode(text: any) {
    return ((/[^019GILOS]/ig).test(text) && (/^[\d\S]{6}$/ig).test(text));
  }

  function isBirthDate(text: any) {
    return ((/^[0-9]{8}$/).test(text));
  }
  
  const ProfileEdit = (
    <React.Fragment>
      <FormContainer
        values={{phone: saveBasicParam.phone, address: saveBasicParam.address, 
          buildingNum: saveBasicParam.buildingNum, email: saveBasicParam.email,
          beforePassword: '', afterPassword: '', afterPasswordCheck: '',
          familyInfo: memberProfile.family_info
        }}
        onSuccess={data => handleSaveBasicInfo(data)}
      >
      <Typography sx={{ color: '#555', p: 2, fontWeight: 700, bgcolor: '#f9f9f9', textAlign: 'center' }}>내정보 수정</Typography>
      <Divider />
      
      <Box sx={{ p: '10px 20px 30px 20px' }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-end', mb:1 }}>
          <PhoneAndroidIcon sx={profileIcon} />
          <TextFieldElement
            name="phone"
            id="input-tel" label="연락처(XXX-XXXX-XXXX)" variant="standard" 
            required
            fullWidth
            InputLabelProps={{ shrink: true }} 
            onChange={(e :any) => {
              setSaveBasicParam((prev) => true ? {...prev, phone: e.target.value} : prev)
            }}
            rules={{
              required: '연락처는 필수 입력입니다.',
              pattern: {
                value: /^[0-9]{3}[-]+[0-9]{4}[-]+[0-9]{4}$/i,
                message: '연락처 형식을 확인해주세요.',
              },
            }}
          />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'flex-end', mb:1, width:'100%' }}>
          <HomeIcon sx={profileIcon} />
          <TextFieldElement
            name="address"
            id="input-address" label="주소" variant="standard" 
            fullWidth
            InputLabelProps={{ shrink: true }} 
            onChange={(e :any) => {
              setSaveBasicParam((prev) => true ? {...prev, address: e.target.value} : prev)
            }}
            inputProps={{ readOnly: true }}
          />
          <Button sx={{fontSize:12, minWidth:50,  border:'1px solid #777', borderRadius:20, color:'#555', bgcolor:'#f9f9f9', fontWeight:700}} onClick={() => setIsOpen(true)}>
            검색
          </Button>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'flex-end', mb:1 }}>
          <HomeIcon sx={profileIcon} />
          <TextFieldElement
            name="buildingNum"
            id="input-address" label="상세주소" variant="standard" 
            fullWidth
            InputLabelProps={{ shrink: true }} 
            onChange={(e :any) => {
              setSaveBasicParam((prev) => true ? {...prev, buildingNum: e.target.value} : prev)
            }}
          />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
          <EmailIcon sx={profileIcon} />
          <TextFieldElement
            name="email"
            id="input-email" label="이메일" variant="standard" 
            required
            fullWidth
            InputLabelProps={{ shrink: true }} 
            onChange={(e :any) => {
              setSaveBasicParam((prev) => true ? {...prev, email: e.target.value} : prev)
            }}
            rules={{
              required: '이메일은 필수 입력입니다.',
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: '이메일 형식을 확인해주세요.',
              },
            }}
          />
          </Box>

          {
            memberProfile.companyType == 'B2B' && memberProfile.family_info === null  && (memberProfile.id.includes('CU') || memberProfile.id.includes('nice'))
              ? <Box sx={{ display: 'flex', alignItems: 'flex-end', mt: 1 }}>
                <ApartmentIcon sx={profileIcon} />
                <TextFieldElement
                  name="code"
                  id="input-code" label="기업코드" variant="standard"
                  fullWidth
                  rules={{
                    required: '필수 입력입니다.',
                  }}
                  onChange={(e: any) => {
                    setSaveBasicParam((prev) => true ? { ...prev, code: e.target.value } : prev);
                    setCode(e.target.value);
                  }}
                  sx={loginField}
                  inputProps={{ readOnly: isCompanyIdCheck }}
                />
                <AssignmentIndIcon sx={profileIcon} />
                <TextFieldElement
                  name="famName"
                  id="input-famName" label="직원이름" variant="standard"
                  fullWidth
                  rules={{
                    required: '필수 입력입니다.',
                  }}
                  onChange={(e: any) => {
                    setFamName(e.target.value);
                  }}
                  inputProps={{ readOnly: isCompanyIdCheck }}
                  sx={loginField}
                />
                <CalendarMonthIcon sx={profileIcon} />
                <TextFieldElement
                  name="famBirthDate"
                  id="input-birth" label="생년월일" variant="standard"
                  placeholder='YYYYMMDD'
                  fullWidth
                  rules={{
                    required: '필수 입력입니다.',
                  }}
                  onChange={(e: any) => {
                    setFamBirthDate(e.target.value);
                  }}
                  inputProps={{ readOnly: isCompanyIdCheck }}
                  sx={{
                    ...loginField, 
                    '& .MuiInputBase-input::placeholder': {
                      fontSize: '10px'
                    },
                  }}
                />

                <Button onClick={() => {
                  if (!isCompanyIdCheck) {
                    if (util.strNull(code) !== '' && util.strNull(famName) !== '' && util.strNull(famBirthDate) !== '') {
                      if (!isCode(code)) {
                        alert('기업코드 형식을 확인해주세요.');
                      } else if (!isBirthDate(famBirthDate)) {
                        alert('생년월일 형식을 확인해주세요.');
                      } else {
                        api.get('permission/companies/check', { params: { code: code, name: famName, birthDate: famBirthDate } }).then(res => {
                          if (res.data.data.employee == null) {
                            alert('등록된 직원이 아닙니다.');
                            return;
                          }

                          setFamSelect('flex');
                          setIsCompanyIdCheck(res.data.success);
                          if (!res.data.success) {
                            alert(res.data.message);
                          } else {
                            // setCompanyId(res.data.data.id);
                            alert('직원 확인되었습니다.');
                          }
                        }).catch(function (error) {
                          console.log(error);
                        });
                      }
                    } else {
                      if (util.strNull(code) === '') {
                        alert('기업코드 입력 후 시도해주세요.');
                      } else if (util.strNull(famName) === '') {
                        alert('이름 입력 후 시도해주세요.');
                      } else if (util.strNull(famBirthDate) === '') {
                        alert('생년월일 입력 후 시도해주세요.');
                      }
                    }
                  } else {
                    alert('직원 확인되었습니다.');
                  }
                }}
                  sx={{ fontSize: 12, minWidth: 60, border: '1px solid #777', borderRadius: 20, color: '#555', bgcolor: '#f9f9f9', fontWeight: 700, p: .5 }}
                >
                  직원확인
                </Button>
              </Box>
              : null
          }

          {
            memberProfile.family_info !== null
              ? <Box sx={{ display: 'flex', alignItems: 'flex-end', mt: 1 }}>
                <WcIcon sx={profileIcon} />
                <TextFieldElement
                  name="familyInfo"
                  id="input-familyInfo" label="관계" variant="standard"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ readOnly: true }}
                />
              </Box>
              : <Box sx={{ display: famSelect, alignItems: 'flex-end', mt: 1 }}>
                <WcIcon sx={profileIcon} />
                <FormControl fullWidth sx={loginField}>
                  <InputLabel id="select-label-active">관계</InputLabel>
                  <Select
                    labelId="select-label-active"
                    id="select-label-active"
                    name="famRelation"
                    // defaultValue="부모"
                    value={famRelation}
                    displayEmpty
                    label="관계"
                    variant="standard"
                    // sx={loginField}
                    MenuProps={{
                      disablePortal: true,
                      // PaperProps: {
                      //   sx: {
                      //     zIndex: 1500,
                      //   },
                      // },
                    }}
                    onChange={(e: any) => {
                      setFamRelation(e.target.value);
                    }}
                  >
                    <MenuItem value="" disabled>
                      관계를 선택해주세요
                    </MenuItem>
                    
                    <MenuItem value="부모">부모</MenuItem>
                    <MenuItem value="배우자">배우자</MenuItem>
                    <MenuItem value="자녀">자녀</MenuItem>
                    <MenuItem value="형제/자매">형제/자매</MenuItem>
                    <MenuItem value="친척">친척</MenuItem>
                  </Select>
                </FormControl>
              </Box>
          }
        </Box>

      <Divider />

      <Typography sx={{ color: '#555', p: 2, fontWeight: 700, bgcolor: '#f9f9f9', textAlign: 'center' }}>비빌번호 변경</Typography>
      <Divider />
      <Box sx={{ p: '10px 20px 20px 20px' }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-end', mb:1 }}>
          <HttpsIcon sx={profileIcon} />
          <TextFieldElement
            name="beforePassword"
            id="input-pw" label="현재 비밀번호" variant="standard" type={'password'}
            fullWidth
            onChange={(e :any) => {
              setSaveBasicParam((prev) => true ? {...prev, beforePassword: e.target.value} : prev)
            }}
          />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'flex-end', mb:1 }}>
          <HttpsIcon sx={profileIcon} />
          <PasswordElement fullWidth id="input-new" label="새로운 비밀번호" variant="standard" type={'password'} name="afterPassword"
            rules={{
              pattern: {
                value: /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,15}$/i,
                message: '영문자+숫자+특수문자 조합 8자리 이상 필수',
              },
            }}
          />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
          <HttpsIcon sx={profileIcon} />
          <PasswordRepeatElement passwordFieldName={'afterPassword'} name="afterPasswordCheck" fullWidth id="input-confirm" 
            label="새로운 비밀번호 확인" variant="standard" type={'password'} 
          />
        </Box>
      </Box>

      <Box sx={{ p: '0px 20px 30px 20px', }}>
        <Stack direction="row" justifyContent="center" alignItems="center" spacing={0} sx={{ mt: 3, bgcolor: '#ffb068', borderRadius: '20px' }}>
          <CareButton variant="contained" sx={{ bgcolor: '#FFB068', color: '#fff' }} onClick={handleClose}>
            취소
          </CareButton>

          <CareButton variant="contained" type={'submit'}>
            저장
          </CareButton>
        </Stack>
      </Box>
      </FormContainer>
    </React.Fragment>
  );

  
  
  return (

    <Stack sx={{ width: '100%', minWidth: 320, background: '#F1F2F4', pb: 5, boxSizing: 'border-box' }} spacing={6}>
      <Top title='내 정보'/>

     
      <Box className="bottomStyle">
        <Snackbar
          open={state.open}
          TransitionComponent={state.Transition}
          message={ProfileEdit}
          key={state.Transition.name}
          autoHideDuration={50000}
          sx={{
            p: 0,
            '& .MuiSnackbarContent-message': { p: 0 },
            '& .MuiPaper-elevation': { display: 'block', bgcolor: '#fff', p: 0 }
          }}
        />
      </Box>

      <Grid sx={{ p: 0, width: '100%', pl: 2, pr: 2,  }}>
        <Box sx={{ m: '0px auto', bgcolor: '#fff', p: '10px', borderRadius: 5, boxSizing: 'border-box', boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)' }}>
          <List>
            <ListItem alignItems="flex-start" sx={listTitle}>성명</ListItem>
            <ListItem alignItems="flex-start" sx={listText}>{memberProfile.name}</ListItem>
            <ListItem alignItems="flex-start" sx={listTitle}>생년월일</ListItem>
            <ListItem alignItems="flex-start" sx={listText}>{memberProfile.birthday}</ListItem>
            <ListItem alignItems="flex-start" sx={listTitle}>연락처</ListItem>
            <ListItem alignItems="flex-start" sx={listText}>{memberProfile.phone_number}</ListItem>
            <ListItem alignItems="flex-start" sx={listTitle}>주소</ListItem>
            <ListItem alignItems="flex-start" sx={listText}>{memberProfile.address + ' ' + memberProfile.buildingNum}</ListItem>
            <ListItem alignItems="flex-start" sx={listTitle}>이메일</ListItem>
            <ListItem alignItems="flex-start" sx={listText}>{memberProfile.email}</ListItem>
          </List>

          <Box sx={{ m: 2 }}>
            <Button variant="contained" sx={ProfileBtnStyle} onClick={handleClick(SlideTransition)}>
              내정보수정
            </Button>
          </Box>
        </Box>
      </Grid>

      <Stack sx={{pb:6}}>
        <Typography sx={{ m: '0px auto 20px auto', width: '100%', textAlign: 'center', fontSize: 16, fontWeight: 600, color: '#555', }}>맞춤형 건강관리를 위해서 기록해주세요.</Typography>

        <Grid sx={{ p: 0, width: '100%', pl: 2, pr: 2, m: '0 !important' }}>
          <Box sx={{ m: '0px auto', bgcolor: '#fff', p: '30px 20px', borderRadius: 5, boxSizing: 'border-box', boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)' }}>
            <Grid container justifyContent="center" sx={{ mb: 2 }}>
              <TextField
                label="신장"
                id=""
                sx={{
                  width: '100%',
                  '& .MuiOutlinedInput-root': {}
                }}
                value={memberProfile.height}
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: <InputAdornment position="start">cm</InputAdornment>,
                }}
                onChange={(e) => { handleChangeHeight(e.target.value) }}
                error={heightError}
                helperText={heightError ? "50 ~ 250 사이의 값을 입력해주세요." : ""}
              />
            </Grid>
            <Grid container justifyContent="center" sx={{ mb: 2 }}>
              <TextField
                label="체중"
                id=""
                sx={{
                  width: '100%',
                  '& .MuiOutlinedInput-root': {}
                }}
                value={memberProfile.weight}
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: <InputAdornment position="start">kg</InputAdornment>,
                }}
                onChange={(e) => { handleChangeWeight(e.target.value) }}
                error={weightError}
                helperText={weightError ? "10 ~ 300 사이의 값을 입력해주세요." : ""}
              />
            </Grid>

            <Grid container justifyContent="center" sx={{ mb: 2 }} >
              <FormControl fullWidth>
                <InputLabel id="select-label-active">평상시 활동량</InputLabel>
                <Select
                  labelId="select-label-active"
                  id="select-label-active"
                  value={memberProfile.work_strength}
                  label="평상시 활동량"
                  onChange={(e :any) => {
                    setMemberProfile((prev) => true ? {...prev, work_strength: e.target.value} : prev)
                  }}
                >
                  <MenuItem value="적음">적음</MenuItem>
                  <MenuItem value="보통">보통</MenuItem>
                  <MenuItem value="많음">많음</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid container justifyContent="center" sx={{ mb: 2 }} >
              <FormControl fullWidth>
                <InputLabel id="select-label-medi">관심 질병</InputLabel>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="multiple-checkbox"
                  label="관심 질병"
                  multiple
                  value={util.strNull(memberProfile.interest_disease) !== '' ? memberProfile.interest_disease.split(',') : []}
                  onChange={(e :any) => {
                    setMemberProfile((prev) => true ? {...prev, interest_disease: e.target.value.join(',')} : prev)
                  }}
                  // input={<OutlinedInput label="Tag" /> }
                  renderValue={(selected :any) => selected.join(',')}
                  MenuProps={MenuProps}
                >
                  {['없음', '당뇨','고혈압','비만','이상지질','기타'].map((name) => (
                    <MenuItem key={name} value={name} sx={{padding: '0px 10px'}} 
                      disabled={
                        memberProfile.interest_disease.length > 0 && (
                          (memberProfile.interest_disease.indexOf('없음') > -1 && name !== '없음')
                          || (memberProfile.interest_disease.indexOf('없음') <= -1 && name === '없음')
                        )
                      }>
                      <Checkbox checked={memberProfile.interest_disease.indexOf(name) > -1} />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid container justifyContent="center" sx={{ mb: 2 }}>
              <FormControl fullWidth>
                <InputLabel id="select-label-par">복용약</InputLabel>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  label="복용약" 
                  multiple
                  value={util.strNull(memberProfile.is_medicine) !== '' ? memberProfile.is_medicine.split(',') : []}
                  onChange={(e :any) => {
                    setMemberProfile((prev) => true ? {...prev, is_medicine: e.target.value.join(',')} : prev)
                  }}
                  // input={<OutlinedInput label="Tag" />}
                  renderValue={(selected :any) => selected.join(',')}
                  MenuProps={MenuProps}
                >
                  {['없음', '당뇨','고혈압','이상지질','건강기능보조제','기타'].map((name) => (
                    <MenuItem key={name} value={name} sx={{padding: '0px 10px'}}
                      disabled={
                        memberProfile.is_medicine.length > 0 && (
                          (memberProfile.is_medicine.indexOf('없음') > -1 && name !== '없음')
                          || (memberProfile.is_medicine.indexOf('없음') <= -1 && name === '없음')
                        )
                      }>
                      <Checkbox checked={memberProfile.is_medicine.indexOf(name) > -1} />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Box sx={BtnStyle}>
              <Button variant="contained" sx={BottomBtnStyle} onClick={handleSaveMyInfo} >
                저장하기
              </Button>
            </Box>
          </Box>
        </Grid>
      </Stack>

      <Modal open={isOpen} onClose={handlePopClose} style={{display:'flex',alignItems:'center',justifyContent:'center', zIndex:9999}}>
        <div>
          <DaumPostcode onComplete={handleComplete} />
        </div>
      </Modal>

      <Bottom />
    </Stack>

  );
}

const ITEM_HEIGHT = 65;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const listTitle = {
  width: '25%',
  display: 'inline-block',
  color: '#555',
  p:0,
  pl:1,
  pb:1,
  fontSize:14
}

const listText = {
  width: '75%',
  display: 'inline-block',
  verticalAlign: 'top',
  fontWeight: 700,
  color: '#555',
  overflowWrap:'break-word',
  fontSize:14,
  pt:0
}

const BtnStyle = {
  display: 'flex',
  justifyContent: 'center',
  m: '3 0',
  mt: 5,
  boxSizing: 'border-box',
};

const ProfileBtnStyle = {
  width: '100%',
  bgcolor: '#fff',
  fontSize: 18,
  fontWeight: 700,
  borderRadius: '30px', p: 1,
  boxSizing: 'border-box',
  color: '#EF8322',
  border: '1px solid #ef8322',
  ':hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color: '#fff'
  },
  ':active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  ':focus': {
    boxShadow: 'none',
  },
};

const BottomBtnStyle = {
  width: '100%',
  bgcolor: '#EF8322',
  fontSize: 18,
  fontWeight: 700,
  borderRadius: '30px', p: 1,
  boxSizing: 'border-box',
  color: '#fff',
  border: '1px solid #ef8322',
  ':hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color: '#fff'
  },
  ':active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  ':focus': {
    boxShadow: 'none',
  },
};

const CareButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  fontWeight: 700,
  padding: '6px 30px',
  lineHeight: 1.5,
  backgroundColor: '#EF8322',
  borderColor: '#EF8322',
  borderRadius: '20px',
  width: '50%',
  '&:hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  '&:focus': {
    boxShadow: 'none',
  },
});

const SmallAvatar = styled(Avatar)(() => ({
  width: 30,
  height: 30,
  border: '2px solid #fff',
}));

const avatarBtn = {
  width: 100,
  height: 100,
  borderRadius: '50%',

  '& input[type="file"]': {
    position: 'absolute',
    width: 100,
    height: 100,
    padding: 0,
    overflow: 'hidden',
    border: 0,
    opacity: 0,
  }
}

const ProgramInfostyle = {
  position: 'absolute' as 'absolute',
  top: '100%',
  left: '50%',
  transform: 'translate(-50%, -0%)',
  maxWidth: '460px',
  p: 5,
};

const ModalTextStyle = {
  textAlign: 'center',
  flex: 1,
  p: '15px 10px 15px 0'
};

const ModalBodyTextStyle = {
  fontSize: 12,
  m: '0 0 5px 0'
};

const profileIcon = {
  color: '#888', mr: 1, my: 0.5, fontSize: 20
}

const loginField = {
  '& input': {
    fontSize: 14
  },
  '& label': {
    // color: '#888',
    // fontSize: 14,
    transform: 'translate(0, -1.5px) scale(0.75)'
  },
  '& label.Mui-focused': {
    // color: '#0d6703',
  },
  '& .MuiInput-underline:after': {
    // borderBottomColor: '#0d6703',
  },
  '& .MuiInputBase-root:before': {
    // borderBottomColor: '#bbb',
  }
};

export default MyPage;